import React from "react";
import DistributionAllocationMethodsFields from "./DistributionAllocationMethodsFields";
import DistributionsOptionsFormFields from "./DistributionsOptionsFormFields";
import FeesFields from "./FeesFields";
import SourceApplicableTable from "./SourceApplicableTable";
import { AddHierarchy, LoanDocumentCard } from "../../../components";
// import DiisbDocCard from "./disbDocCard";

const InServiceForm = (props) => {
  const { isSave, isEdit, fields } = props;
  // props.values.loanDocumentType = [
  //   {
  //     description: "Spousal consent",
  //     isRequired: false,

  //     isAdded: false,

  //     isViewOnly: true,
  //   },

  //   {
  //     description: "Hardship documentation",
  //     isRequired: false,
  //     isAdded: false,
  //     isViewOnly: true,
  //   },
  //   {
  //     description: "Birth Certificate or adoption Document",
  //     isRequired: true,
  //     isAdded: false,
  //     isViewOnly: true,
  //   },
  // ];

  return (
    <div>
      <DistributionsOptionsFormFields {...props} />
      <SourceApplicableTable {...props} />
      <DistributionAllocationMethodsFields {...props} />
      <FeesFields {...props} />
      <LoanDocumentCard
        {...props}
        fields={fields}
        isEdit={isEdit}
        isSave={isSave}
        fieldArrayName={fields.withdrawalDocumentType}
      />
      {/* <DiisbDocCard {...props}  /> */}
      <AddHierarchy {...props} />
    </div>
  );
};

export default InServiceForm;
